import API from './api';

export function getKlarnaInformation(address) {
  return dispatch => dispatch(API.doNetworkRequest('/v2/klarna/information', JSON.stringify(address)))
    .then((response) => {
      if (response && (response.status === 200 || response.status === 202) && response.msg) {
        return response.msg;
      }
      throw new Error(`Error getting Klarna information from API: ${JSON.stringify(response)}`);
    })
    .catch((error) => {
      throw new Error(`Caught error getting Klarna information from API: ${error}`);
    });
}

export function getKlarnaSession(requiredInformation) {
  return dispatch => dispatch(API.doNetworkRequest('/v2/klarna/session', JSON.stringify(requiredInformation)))
    .then((response) => {
      if (response && response.status === 200 && response.msg) {
        return response.msg;
      }
      throw new Error(`Error authorising Klarna session from API: ${JSON.stringify(response)}`);
    })
    .catch((error) => {
      throw new Error(`Caught error authorising Klarna session from API: ${error}`);
    });
}

export function setKlarnaAuthorised(authorisationDetails, klarnaInformation, shippingAddress, billingAddress, customerDetails) {
  const data = {
    authorisationDetails, klarnaInformation, shippingAddress, billingAddress, customerDetails,
  };
  return dispatch => dispatch(API.doNetworkRequest('/v2/klarna/authorised', JSON.stringify(data)))
    .then((response) => {
      if (response && response.status === 200) {
        return response.msg;
      }
      throw new Error(`Error setting klarna authorised on API: ${JSON.stringify(response)}`);
    })
    .catch((error) => {
      throw new Error(`Caught error setting klarna authorised on API: ${error}`);
    });
}
